<template>
  <transition name="fade">
    <div class="dialog-wrapper" v-if="visible" @click.self="close">
      <div class="dialog-box">
        <div class="dialog-header">
          <span class="dialog-title">{{title}}</span>
          <a class="dialog-close" @click="close"></a>
        </div>
        <div class="dialog-body">
          <slot></slot>
        </div>
        <div class="dialog-footer"></div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "dialog-box",
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit('close')
    },
    show() {
      this.visible = true;
      this.$emit('show')
    }
  }
};
</script>

<style lang="scss">
.dialog-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  background: rgba(#000, 0.6);
  overflow: auto;

  .dialog-box {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 6.84rem;
    height: fit-content;
    box-shadow: 0 0.01rem 0.03rem rgba(#000, 0.3);
    transform: scale(.8);

    .dialog-header {
      @include bgImg("pop-header.png");
      width: 6.84rem;
      height: 0.5rem;
      text-align: center;
      padding: 0.1rem;

      .dialog-close {
        @include bgImg("btn-colse.png");
        width: 0.69rem;
        height: 0.77rem;
        position: absolute;
        top: -0.09rem;
        right: 0.05rem;
        padding: 0;
        cursor: pointer;
      }

      .dialog-title {
        font-size: 0.24rem;
        color: #e7f7ff;
        margin: 20px 0;
      }
    }
    .dialog-body {
      @include bgImg("pop-body.png");
      background-repeat: repeat-y;
      background-size: contain;
      width: 6.84rem;
      margin-bottom: -1px;
      padding: 0.3rem 0.4rem 0 0.4rem;
    }

    .dialog-footer {
      @include bgImg("pop-footer.png");
      width: 6.84rem;
      height: 0.29rem;
    }
  }
}
</style>